/* Package JSON Import will be here */
import React from "react";
import { Icon, Table, Header, Segment, Pagination, Button, Checkbox, List, Grid, Modal, Form, Search } from 'semantic-ui-react';
import { Select } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import InfinteScroll from "react-infinite-scroll-component";
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../../src/config/appConstants';
import './employee.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import NoResultFound from "../sharedComponent/noResultFound";
import * as utility from '../../services/utility';
/* Project Import will be here */

const EmployeeComponent = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    const selectedEmployeeId = props?.employee?.selectedEmployee?.id;

    return (
        <Layout>

            {/* HEADER */}
            <Segment className="header-section">
                <Header as="h3">
                    <Icon name="user outline"></Icon>
                    <span>Employees</span>
                </Header>
                <div style={{ display: 'flex', color: '#2196F3', alignItems: 'center' }}>
                    <h4 style={{ margin: '0' }}>Status:</h4>
                    <Select value={props.employee.employeeStatus} onChange={props.handleChange}>{props.renderOptions()}</Select>
                    {
                        props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_ADD_BUTTON) &&
                        <i aria-hidden="true" onClick={() => props.onOpenModal()} style={myiconstyle} className="plus circle icon"></i>
                    }
                </div>
            </Segment>

            {/* EMPLOYEES, PROJECT, DIVISION, ASSIGNED DEVICES */}
            <div className="tableVertical">
                <Table className="ui celled table">
                    <Table.Header>
                        <Table.Row className="tableRow">
                            <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                            <Table.HeaderCell className="text-left">Employee Number - Name
                                <Search value={props.employee.searchEmployeeText} onSearchChange={props.onEmployeeSearch} placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-left divisionNumber">Division Number
                                <Search className="theader" onSearchChange={props.onDivisionSearch} placeholder={Constants.SEARCH_PLACEHOLDER} value={props.employee.searchDivisionText} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-left divisionNumber">Project Number
                                <Search className="theader" onSearchChange={props.onProjectSearch} placeholder={Constants.SEARCH_PLACEHOLDER} value={props.employee.searchProjectText} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-left">Devices
                                <Search onSearchChange={props.onDeviceSearch} placeholder={Constants.SEARCH_PLACEHOLDER} value={props.employee.searchDeviceText} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            props?.employee?.employeeList?.length > 0 ?
                                <Table.Row style={{ verticalAlign: 'top' }}>
                                    <Table.Cell className="tableCell">
                                        <List selection>
                                            {
                                                props?.employee?.employeeList?.map(({ id }) => (
                                                    <div key={id} className={(props.user.roleName === Constants.SYSTEM_ADMIN_ROLE_NAME || props.user.roleName === Constants.ADMIN_ROLE_NAME || props.user.roleName === Constants.CONTRIBUTE) && props.employee.employeeStatus.toLowerCase() === Constants.STATUS_INACTIVE ? "iconsEmployeePage" : props.user.roleName === Constants.READ_ONLY ? "iconsEmployeePage" : "iconsPage"}>
                                                        {
                                                            props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON) && props.employee.employeeStatus.toLowerCase() === Constants.EMP_STATUS_ACTIVE &&
                                                            <img className="imageSize" src={require('../../assets/images/editIcon.png')} onClick={() => props.editAssignDevices({ modalOpen: true, employeeId: id })} alt="edit" />
                                                        }
                                                        <Icon className="myiconstyle" edit="true" name='pencil' onClick={() => props.onOpenModal({ employeeId: id, edit: true })} />
                                                    </div>
                                                ))
                                            }
                                        </List>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <List selection animated style={{ display: 'grid' }}>
                                            {
                                                props?.employee?.employeeList?.length > 0
                                                    ?
                                                    props.employee.employeeList.map(({ fullName, employeeNumber, id }) => (
                                                        <List.Item active={selectedEmployeeId === id} key={id}>
                                                            <div className={selectedEmployeeId === id ? "listDescriptionBold" : "listDescription"} onClick={() => props.setSelectedEmployee(id)}>
                                                                {employeeNumber}-{fullName}
                                                            </div>
                                                        </List.Item>
                                                    ))
                                                    :
                                                    <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                            }
                                        </List>
                                    </Table.Cell>
                                    <Table.Cell className="divisionNumber">
                                        <List className="gridRowHeight">
                                            {
                                                props?.employee?.selectedEmpProjectAndDivision?.divisions?.length > 0
                                                    ?
                                                    props.employee.selectedEmpProjectAndDivision.divisions.map((division) => (
                                                        <div key={division} className="ptb5">{division}</div>
                                                    ))
                                                    :
                                                    <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                            }
                                        </List>
                                    </Table.Cell>
                                    <Table.Cell className="divisionNumber">
                                        <List className="gridRowHeight">
                                            {
                                                props?.employee?.selectedEmpProjectAndDivision?.projectNumbers?.length > 0
                                                    ?
                                                    props.employee.selectedEmpProjectAndDivision.projectNumbers.map((projectNumber) => (
                                                        <div key={projectNumber} className="ptb5">{projectNumber}</div>
                                                    ))
                                                    :
                                                    <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                            }
                                        </List>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <div id="assignedDevicesScrollForMainPage"
                                            style={{
                                                minHeight: "700px",
                                                maxHeight: "3000px",
                                                overflow: props?.employee?.assignedDevicesIntheMainPage?.length > 0 ? "auto" : "hidden"
                                            }}
                                        >
                                            <InfinteScroll
                                                dataLength={props?.employee?.assignedDevicesIntheMainPage?.length}
                                                hasMore={true}
                                                next={() => props.getAlreadyAssignedDevicesForEmployeePage(true)}
                                                scrollableTarget="assignedDevicesScrollForMainPage"
                                                style={{
                                                    overflow: props?.employee?.assignedDevicesIntheMainPage?.length > 0 ? "auto" : "hidden"
                                                }}
                                            >
                                                <List>
                                                    {
                                                        props?.employee?.assignedDevicesIntheMainPage?.length > 0
                                                            ?
                                                            props.employee.assignedDevicesIntheMainPage.map(({ deviceEmpID }, i) => (
                                                                <div key={i} className="ptb5">{deviceEmpID}</div>
                                                            ))
                                                            :
                                                            <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                                    }
                                                </List>
                                            </InfinteScroll>
                                        </div>
                                    </Table.Cell>

                                </Table.Row>
                                :
                                <Table.Row style={{ width: '100%' }}>
                                    <Table.Cell colSpan="5">
                                        <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                    </Table.Cell>
                                </Table.Row>
                        }
                    </Table.Body>

                </Table>
            </div>

            {/* ADD OR EDIT EMPLOYEE MODAL */}
            <Modal closeIcon open={props.employee.isEditEmployee} closeOnDimmerClick={false} onClose={() => props.onCloseModal()}>
                <Modal.Header className="headerColor text-color">Employee Details</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Input
                                    label="Employee Name:"
                                    placeholder='Employee Name'
                                    name="employeeName"
                                    onChange={props.handleFormChange}
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.fullName ? props.employee.selectedEmployeeDetails.fullName : ""}
                                    readOnly={props.employee.isAddEmployee || (props.employee.isManuallyAddedEmployee && (props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON))) ? false : true}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Input
                                    label="Employee Number:"
                                    placeholder='Employee Number'
                                    name="employeeNumber"
                                    onChange={(e) => { utility.allowOnlyPositiveIntegerValue(e); props.handleFormChange(e, { name: 'employeeNumber', value: e.target.value }) }}
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.employeeNumber ? props.employee.selectedEmployeeDetails.employeeNumber : ""}
                                    readOnly={props.employee.isAddEmployee || (props.employee.isManuallyAddedEmployee && (props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON))) ? false : true}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Select
                                    label='Status'
                                    name='status'
                                    fluid
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.employeeStatusFlag ? props.employee.selectedEmployeeDetails.employeeStatusFlag.toLowerCase() : ""}
                                    options={props.employee.employeeStatusOptions}
                                    placeholder='Status'
                                    onChange={props.handleFormChange}
                                    disabled={(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_STATUS_EDIT_BUTTON) && (props.employee.isManuallyAddedEmployee || props.employee.isAddEmployee)) ? false : true}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Input
                                    label="Title:"
                                    placeholder='Title'
                                    name="employeeTitle"
                                    onChange={props.handleFormChange}
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.jobTitle ? props.employee.selectedEmployeeDetails.jobTitle : ""}
                                    readOnly={props.employee.isAddEmployee || (props.employee.isManuallyAddedEmployee && (props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON))) ? false : true}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Input
                                    icon={(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON) && !props.employee.isManuallyAddedEmployee) ? <Icon name='pencil alternate' /> : ''}
                                    label="Email Address:"
                                    placeholder='Email Address'
                                    name="employeeEmailAddress"
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.emailAddress ? props.employee.selectedEmployeeDetails.emailAddress : ""}
                                    onChange={props.handleFormChange}
                                    readOnly={(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON)) ? false : true} />
                            </Form.Field>
                            <Form.Field>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker className="issue-field w-100"
                                        placeholder="MM/dd/yyyy"
                                        value={props.employee && props.employee.selectedEmployeeDetails ? props.employee.selectedEmployeeDetails.hireDate : ""}
                                        onChange={date => props.handleDateChange(date)}
                                        inputProps={{ readOnly: true }}
                                        format="MM/dd/yyyy"
                                        label="Hire Date:"
                                        name="employeeHireDate"
                                        InputLabelProps={{ shrink: true }}
                                        readOnly={props.employee.isAddEmployee || (props.employee.isManuallyAddedEmployee && (props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON))) ? false : true}
                                    />
                                </MuiPickersUtilsProvider>
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Select
                                    label='Division Number:'
                                    name='divisionId'
                                    fluid search selection
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.divisionId ? props.employee.selectedEmployeeDetails.divisionId : ""}
                                    options={props.employee.employeeDivisions}
                                    placeholder='Division Number'
                                    onChange={props.handleFormChange}
                                    disabled={(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON)) ? false : true} />
                            </Form.Field>
                            <Form.Field>
                                <Form.Input
                                    label="Union Number:"
                                    placeholder='Union Number'
                                    name="unionNumber"
                                    onChange={(e) => { utility.allowOnlyPositiveIntegerValue(e); props.handleFormChange(e, { name: 'unionNumber', value: e.target.value }) }}
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.unionNumber ? props.employee.selectedEmployeeDetails.unionNumber : ""}
                                    readOnly={props.employee.isAddEmployee || (props.employee.isManuallyAddedEmployee && (props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON))) ? false : true}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Input
                                    icon={(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON) && !props.employee.isManuallyAddedEmployee) ? <Icon name='pencil alternate' /> : ''}
                                    label="Project Number:"
                                    placeholder='Project Number'
                                    name="projectNumber"
                                    value={props.employee.selectedEmployeeDetails && props.employee.selectedEmployeeDetails.projectNumber ? props.employee.selectedEmployeeDetails.projectNumber : ""}
                                    onChange={(e) => { utility.allowOnlyPositiveIntegerValue(e); props.handleFormChange(e, { name: 'projectNumber', value: e.target.value }) }}
                                    readOnly={(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON)) ? false : true}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Checkbox className="checkbox-override stickyHeader" checked={props.employee.selectedEmployeeDetails.isManagerAccessEnabled} name='managerAccess' label='Manager Access' onChange={(e, value) => { props.handleManagerAccessChange(value.checked) }} readOnly={(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON)) ? false : true} />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                {
                    props.user.claimValue.includes(Constants.BUTTON_CLAIMS.EMPLOYEE_EDIT_BUTTON) &&
                    <Modal.Actions>
                        <Button primary onClick={props.formSubmit} disabled={props.employee.isSaveBtnDisabled}>Save</Button>
                        <Button secondary onClick={() => props.onCloseModal()}>Back</Button>
                    </Modal.Actions>
                }
            </Modal>

            {/* ASSIGN OR UNASSIGN DEVICES MODAL */}
            <Modal closeIcon open={props.employee.isEditAssignDevices} closeOnDimmerClick={false} onClose={() => props.editAssignDevices({ modalOpen: false })}>
                <Modal.Header className="headerColor text-color">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={7}>Assign Employee To Devices</Grid.Column>
                            <Grid.Column width={2}></Grid.Column>
                            <Grid.Column width={7}>
                                <span className="employeeDetail">{props.employee.selectedEmployee ? props.employee.selectedEmployee.employeeNumber + " - " + props.employee.selectedEmployee.fullName : ""}</span>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content scrolling>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={7}>
                                <Header className="headerColor text-color">Unassigned Devices</Header>
                                <Grid.Column width={6} className="gridColoumn">
                                    <Search className="searchWidth" onSearchChange={props.onUnAssignDeviceSearch} placeholder={Constants.SEARCH_DEVICE_PLACEHOLDER} />
                                </Grid.Column>
                                <Grid celled>
                                    <Grid.Row>
                                        <Grid.Column className="columnHeight stickyData d-flex-imp flex-column-imp">
                                            <Checkbox
                                                className="checkbox-override rightCheckbox stickyHeader mb0"
                                                checked={props.employee.selectAllUnAssignedDevices}
                                                name='selectAll'
                                                label='Select All'
                                                onChange={(e, value) => props.selectOrUnSelectAllUnAssignedDevices(e, value)}
                                            />
                                            <div id="unAssignedDevicesScroll"
                                                style={{
                                                    height: "100%",
                                                    overflow: props?.employee?.unAssignedDevicesInTheDeviceModal?.length > 0 ? 'auto' : 'hidden'
                                                }}
                                            >
                                                <InfinteScroll style={{ height: '100%', overflow: 'initial' }}
                                                    dataLength={props?.employee?.unAssignedDevicesInTheDeviceModal?.length}
                                                    hasMore={true}
                                                    next={() => props.fetchNext(Constants.UNASSIGN_DEVICE)}
                                                    scrollableTarget="unAssignedDevicesScroll"
                                                >
                                                    <List selection animated verticalAlign='middle'>
                                                        {
                                                            props?.employee?.unAssignedDevicesInTheDeviceModal?.length > 0
                                                                ?
                                                                props.employee.unAssignedDevicesInTheDeviceModal.map(({ deviceEmpID, deviceID }, index) => (
                                                                    <List.Item key={`${deviceEmpID}-${deviceID}-${index}`} active={props.employee.selectedUnAssignedDevicesMap.has(deviceID)} className="font-align">
                                                                        <List.Content textalign="center">
                                                                            {
                                                                                props.employee.selectAllUnAssignedDevices ?
                                                                                    <List.Description className={"listDescriptionBold"}>
                                                                                        <Checkbox checked={props.employee.selectAllUnAssignedDevices} label={deviceEmpID} onChange={(e, value) => props.addOrRemoveSelectedUnAssignedDevice(deviceID)} />
                                                                                    </List.Description>
                                                                                    :
                                                                                    <List.Description className={props.employee.selectedUnAssignedDevicesMap.has(deviceID) ? "listDescriptionBold" : "listDescription"} onClick={() => props.addOrRemoveSelectedUnAssignedDevice(deviceID)}>{deviceEmpID}</List.Description>
                                                                            }
                                                                        </List.Content>
                                                                    </List.Item>
                                                                ))
                                                                :
                                                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                                        }
                                                    </List>
                                                </InfinteScroll>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={2} className="arrowPlacing">
                                <div>
                                    <div className="arrowSpacing">
                                        <Icon name="arrow right" className="arrowWidth" onClick={() => props.assignOrUnassignDevices(true)} />
                                    </div>
                                    <div>
                                        <Icon name="arrow left" className="arrowWidth" onClick={() => props.assignOrUnassignDevices(false)} />
                                    </div>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={7}>
                                <Header className="headerColor text-color">Assigned Devices</Header>
                                <Grid.Column className="gridColoumn">
                                    <Search className="searchWidth" onSearchChange={props.onAssignedDeviceSearch} placeholder={Constants.SEARCH_DEVICE_PLACEHOLDER} />
                                </Grid.Column>
                                <Grid celled>
                                    <Grid.Row>
                                        <Grid.Column className="columnHeight stickyData d-flex-imp flex-column-imp">
                                            <Checkbox className="checkbox-override stickyHeader" checked={props.employee.selectAllAssignedDevices} name='selectAll' label='Select All' onChange={(e, value) => props.selectOrUnSelectAllAssignedDevices(e, value)} />
                                            <div id="assignedDevicesScroll"
                                                style={{
                                                    height: "100%",
                                                    overflow: props?.employee?.assignedDevicesInTheDeviceModal?.length > 0 ? 'auto' : 'hidden'
                                                }}
                                            >

                                                <InfinteScroll style={{ height: '100%', overflow: 'initial' }}
                                                    dataLength={props?.employee?.assignedDevicesInTheDeviceModal?.length}
                                                    hasMore={true}
                                                    next={() => props.fetchNext(Constants.ASSIGN_DEVICE)}
                                                    scrollableTarget="assignedDevicesScroll"
                                                >
                                                    <List selection animated verticalAlign='middle'>
                                                        {
                                                            props?.employee?.assignedDevicesInTheDeviceModal?.length > 0
                                                                ?
                                                                props.employee.assignedDevicesInTheDeviceModal.map(({ deviceEmpID, deviceID }, index) => (
                                                                    <List.Item key={`${deviceEmpID}-${deviceID}-${index}`} active={props.employee.selectedAssignedDevicesMap.has(deviceID)} className="font-align">
                                                                        <List.Content textalign="center">
                                                                            {
                                                                                props.employee.selectAllAssignedDevices
                                                                                    ?
                                                                                    <List.Description className={"listDescriptionBold"}>
                                                                                        <Checkbox checked={props.employee.selectAllAssignedDevices} label={deviceEmpID} onChange={(e, value) => props.addOrRemoveSelectedAssignedDevice(deviceID)} />
                                                                                    </List.Description>
                                                                                    :
                                                                                    <List.Description className={props.employee.selectedAssignedDevicesMap.has(deviceID) ? "listDescriptionBold" : "listDescription"} onClick={() => props.addOrRemoveSelectedAssignedDevice(deviceID)}>{deviceEmpID}</List.Description>
                                                                            }
                                                                        </List.Content>
                                                                    </List.Item>
                                                                ))
                                                                :
                                                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                                        }
                                                    </List>
                                                </InfinteScroll>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button primary onClick={() => props.saveAssignOrUnassignDevices({ modalOpen: false })} disabled={props.employee.isSaveBtnDisabled}>Save</Button>
                    <Button secondary onClick={() => props.editAssignDevices({ modalOpen: false })}>Back</Button>
                </Modal.Actions>
            </Modal>

            {/* PAGINATION */}
            {
                props?.employee?.employeeList?.length > 0 &&
                <Pagination
                    floated="right"
                    activePage={props.employee.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.employee.pagination.totalCount}
                />
            }
        </Layout >
    );
}

export default EmployeeComponent;

EmployeeComponent.displayName = "EmployeeComponent";